export default "__VITE_ASSET__D74JGrC5__"